import React, { useEffect, useState, useRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import { API_POST, API_GET } from "../../../services/api.service";
import { getTemplate } from "../notificationsMessages";
import { getManager } from "../../common/helper";
import SupportDevMappingPopup from "../../SupportDev/SupportDevMappingPopup";
import { Box } from "@material-ui/core";
import { subCategory } from "../constants.js";

const statusOptions = [
    {
        key: "Pending",
        value: "Pending"
    },
    {
        key: "In-Progress",
        value: "In-Progress"
    },
    {
        key: "Move to development",
        value: "Move to development"
    },
    {
        key: "Move to Administration",
        value: "Move to Administration"
    },
    {
        key: "Followups",
        value: "Followups"
    },

    {
        key: "Resolved",
        value: "Resolved"
    }
];

const SupportEditModal = ({ open, onClose, ticketId, user, onSaved, ticketAssignedToOption }) => {
  const [ticket, setTicket] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [category, setCategory] = useState([]);
  const [subCategoryOption, setsubCategoryOption] = useState([]);
  const [categoryData, setcategoryData] = useState([]);
  const [otpNumber, setOtpNumber] = useState("");
  const [managerOptions, setManagerOptions] = useState([]);
  const [mappingSaved, setMappingSaved] = useState(false);
  const [mappedDevTicket, setMappedDevTicket] = useState(null); // <-- Track mapped dev ticket
  const [showCategoryPopup, setShowCategoryPopup] = useState(false);
  const [showConcernPopup, setShowConcernPopup] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [newConcern, setNewConcern] = useState("");
  const [customCategories, setCustomCategories] = useState([]);
  const [customConcerns, setCustomConcerns] = useState({});
  const mappingRef = useRef();

  useEffect(() => {
    getCategory()
    if (open && ticketId) {
      
      setLoading(true);
      API_POST("action/getdata", {
        root: "supportTickets",
        con: { _id: ticketId },
      })
        .then(({ data }) => {


          if (data && data[0]){

            data[0]['sendNotification'] = true;
            setTicket(data[0]);

          } 
          categoryChange({target:{value:data[0].category}});
        })
        .catch(() => setError("Failed to load ticket data"))
        .finally(() => setLoading(false));
      // Load manager options
      if (ticketAssignedToOption && Array.isArray(ticketAssignedToOption)) {
        setManagerOptions(ticketAssignedToOption.map(opt => ({ value: opt.key || opt.value, label: opt.value || opt.label })));
      } else {
        const managers = getManager(user.admin);
        setManagerOptions(managers.map(m => ({ value: m.email, label: m.first_name || m.email })));
      }
      
    } else {
      setTicket(null);
      setError("");
      setOtp("");
      setOtpSent(false);
      setOtpNumber("");
    }

  }, [open, ticketId, user.admin, ticketAssignedToOption]);


  const getCategory = async () => {
    try {
      const registerRequest = await API_POST("action/getdata", {
        root: "supportCategories",
        con: {},
      });

      if (registerRequest.data && registerRequest.data[0]) {
        const record = registerRequest.data;
        const categorylist = record.map((v) => {
          return { key: v.categoryName, value: v.categoryName,visibleToRoles:v.visibleToRoles };
        });
       setCategory(categorylist);
       setcategoryData(record);
      }
    } catch (error) {
      console.error("Error editing record:", error);
    }
  };


  const categoryChange = (e) => {
    const categoryValue = e.target.value;
    
    const subcat = categoryData.find((item) => item.categoryName === categoryValue) || subCategory[categoryValue] || [];
    console.log("subcat", subcat , category, categoryValue);
    
    let subcatoption = [];
    if (subcat.subcategories) {
      subcatoption = subcat.subcategories.map((item) => ({
        key: item.name,
        value: item.name,
      }));
    } else if (Array.isArray(subcat)) {
      // Fallback for static subCategory array
      subcatoption = subcat.map((item) => ({
        key: item,
        value: item,
      }));
    }

    console.log("categoryddddddd",subcatoption);


    setsubCategoryOption(subcatoption);
    handleChange(e);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTicket((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // Open mapping popup if status is 'Move to development'
    if (name === "status" && value === "Move to development") {
      // setShowMappingPopup(true); // Removed as per edit hint
      setMappingSaved(false);
    }
  };

  // Notification logic from supportForm
  const sendNotification = async ({ data, userType, email, phone }) => {
    try {
      const { html, message, subject } = getTemplate(data, userType);
      let tou = email;
      await API_POST("commPublic/sendMessages", {
        phone,
        tou,
        bcc: "Support@techmet,in",
        type: ["email", "whatsapp"],
        from: "betyphon.crm@gmail.com",
        to: tou,
        email: tou,
        subject,
        message: message,
        html: html,
      });
    } catch (error) {
      throw new Error("Error sending notification");
    }
  };

  const notificationBell = async (admin, message) => {
    try {
      await API_POST("action/addRecord", {
        root: "notifications",
        body: {
          type: "message",
          IsActive: true,
          read: 0,
          admin,
          user: admin,
          message,
          link: ticketId,
        },
      });
    } catch (error) {
      // Not critical, so just log
      console.error("Error creating notification:", error);
    }
  };

  const handleSendOtp = async () => {
    if (!ticket) return;
    const val = Math.floor(1000 + Math.random() * 9000);
    try {
      await API_POST("commPublic/sendMessages", {
        phone: ticket.customerPhone || ticket.phone,
        bcc: "Support@techmet,in",
        type: ["sms", "whatsapp"],
        from: "betyphon.crm@gmail.com",
        message: `BTYPHN - Dear User, Your OTP is ${val} for BeTyphon`,
      });
      setOtpNumber(val.toString());
      setOtpSent(true);
    } catch (error) {
      setError("Failed to send OTP");
    }
  };

  const handleMappingSuccess = () => {
    setMappingSaved(true);
    // setShowMappingPopup(false); // Removed as per edit hint
  };

  const handleAddCategory = () => {
    if (newCategory.trim()) {
      const newCat = { key: newCategory.trim(), value: newCategory.trim() };
      setCustomCategories(prev => [...prev, newCat]);
      setTicket(prev => ({ ...prev, category: newCategory.trim() }));
      setNewCategory("");
      setShowCategoryPopup(false);
    }
  };

  const handleAddConcern = () => {
    if (newConcern.trim() && ticket.category) {
      const newConc = newConcern.trim();
      setCustomConcerns(prev => ({
        ...prev,
        [ticket.category]: [...(prev[ticket.category] || []), newConc]
      }));
      setTicket(prev => ({ ...prev, subCategory: newConc }));
      setNewConcern("");
      setShowConcernPopup(false);
    }
  };

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    if (value === "Other") {
      setShowCategoryPopup(true);
    } else {
      setTicket(prev => ({ ...prev, category: value, subCategory: "" }));
    }
  };

  const handleConcernChange = (e) => {
    const value = e.target.value;
    if (value === "Other") {
      setShowCategoryPopup(true);
    } else {
      setTicket(prev => ({ ...prev, subCategory: value }));
    }
  };

  const handleSave = async () => {
    setError("");
    if (!ticket) return;
    // If mapping is required but not yet saved, trigger mapping save
    if (ticket.status === "Move to development" &&  mappingRef.current) {
      await mappingRef.current.saveMapping();
    }
    if (user.is_superuser && ticket.status == "Followups" && !ticket.scheduledTime) {
      setError("Scheduled time is mandatory");
      return;
    }

    if (ticket.status === "Resolved") {
      if (!otp || otp !== otpNumber) {
        setError("OTP verification failed");
        return;
      }
    }
    setLoading(true);
    try {
      let payload = {
        ...ticket,
        updatedOn: new Date(),
        updatedBy: user.username,
      };
      if (ticket.status === "Resolved") {
        payload.resolvedOn = new Date();
      }
      // Get RM info if needed
      let allocatedRm = null;
      if (payload.admin) {
        const rmRes = await API_GET(`register/GetProfileData?username=${payload.admin}`);
        if (rmRes.success && rmRes.data.allocatedRm) {
          payload.assignTo = rmRes.data.allocatedRm.email;
          allocatedRm = rmRes.data.allocatedRm;
        }
      }

      if(!payload.category) delete payload.category;

      if(!payload.subCategory) delete payload.subCategory;

      // Save the record
      await API_POST("action/update", {
        root: "supportTickets",
        querydata: { _id: ticketId },
        body: payload,
      });
      // --- Update mapped dev ticket if present ---
      if (mappedDevTicket && mappedDevTicket._id) {
        // Fetch latest dev ticket data
        const { data } = await API_POST("action/getdata", {
          root: "supportDevTickets",
          con: { _id: mappedDevTicket._id }
        });
        const devTicket = data && data[0];
        if (devTicket) {
          const mappedIds = devTicket.mappedId || [];
          if (!mappedIds.includes(ticketId)) {
            await API_POST("action/update", {
              root: "supportDevTickets",
              querydata: { _id: devTicket._id },
              body: { mappedId: [...mappedIds, ticketId] }
            });
          }
        }
      }
      // --- End dev ticket update ---
      // Send notifications (to RM and user)
      const notificationPromises = [];
      if (allocatedRm && allocatedRm.phone && allocatedRm.email) {
        notificationPromises.push(
          sendNotification({
            data: payload,
            phone: allocatedRm.phone,
            email: allocatedRm.email,
            userType: "RM_MANAGER",
          })
        );
      }
      if (payload.sendNotification && (payload.phone || payload.customerPhone) && (payload.email || payload.customerEmail)) {
        notificationPromises.push(
          sendNotification({
            data: payload,
            phone: payload.customerPhone || payload.phone,
            email: payload.customerEmail || payload.email,
            userType: "USER",
          })
        );
      }
      await Promise.all(notificationPromises);
      // Notification bell
      await notificationBell(payload.admin, `Query Reply - ${payload.adminComment}`);
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      setError(err.message || "Failed to save changes");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Edit Ticket</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        {ticket && (
          <Grid container spacing={2}>
            {/* Left: Read-only info as plain text */}
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <div style={{ marginBottom: 16 }}><b>Comment:</b><br />{ticket.comment || '-'}</div>
              <div style={{ marginBottom: 16 }}><b>Created Date:</b><br />{window.moment(ticket.createdOn).format("DD-MMM-YYYY hh:mm")}</div>
              <div style={{ marginBottom: 16 }}><b>Category:</b><br />{ticket.category || '-'}</div>
              <div style={{ marginBottom: 16 }}><b>Concern:</b><br />{ticket.subCategory || '-'}</div>
              <div style={{ marginBottom: 16 }}><b>Company:</b><br />{ticket.company || '-'}</div>
              <div style={{ marginBottom: 16 }}><b>Phone:</b><br />{ticket.customerPhone || '-'}</div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={ticket.sendNotification}
                    onChange={handleChange}
                    name="sendNotification"
                    color="primary"
                  />
                }
                label="Send Notification"
              />
            </Grid>
            {/* Right: Editable fields */}

            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <TextField
                label="Category"
                name="category"
                select
                value={ticket.category || ''}
                onChange={categoryChange}
                fullWidth
                margin="normal"
              >
                {category.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.key}</MenuItem>
                ))}
              </TextField>

              <TextField
                label="Concern (Sub Category)"
                name="subCategory"
                select
                value={ticket.subCategory || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                disabled={!ticket.category}
              >
                {ticket.category && subCategoryOption ? 
                  subCategoryOption.map((opt) => (
                    <MenuItem key={opt.key} value={opt.key}>{opt.key}</MenuItem>
                  )) : 
                  <MenuItem value="">Select Category First</MenuItem>
                }
              </TextField>

              <TextField
                label="Admin Comment"
                name="adminComment"
                value={ticket.adminComment || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              {
                ticket.status === "Followups" &&               <TextField
                label="Schedule Time"
                name="scheduledTime"
                type="datetime-local"
                value={ticket.scheduledTime ? (ticket.scheduledTime.length > 16 ? ticket.scheduledTime.substring(0, 16) : ticket.scheduledTime) : ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
                InputLabelProps={{ shrink: true }}
              />
              }

              <TextField
                label="Admin Status"
                name="status"
                select
                value={ticket.status || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
              >
                {statusOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.key}</MenuItem>
                ))}
              </TextField>
              <TextField
                label="Assign To"
                name="assignTo"
                select
                value={ticket.assignTo || ''}
                onChange={handleChange}
                fullWidth
                margin="normal"
              >
                {managerOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                ))}
              </TextField>

                          {/* Inline dev mapping form if status is 'Move to development' */}
            {ticket.status === "Move to development" && (
              <Grid item xs={12} style={{ marginTop: 12 }}>
                <SupportDevMappingPopup
                  ref={mappingRef}
                  open={true}
                  onClose={() => {}}
                  onSuccess={handleMappingSuccess}
                  supportId={ticketId}
                  user={user}
                  inline
                  setMapping={setMappedDevTicket} // <-- Pass setMapping
                 
                  cardProps={{
                    style: {
                      width: '100%',
                      maxWidth: '100%',
                      margin: 0,
                     
                      borderRadius: 12,
                      padding: 24,
                   
                    }
                  }}
                />
              </Grid>
            )}
              {/* OTP Section */}
              {ticket.status === "Resolved" && (
                <div style={{ marginTop: 16 }}>
                  <Button variant="outlined" color="primary" onClick={handleSendOtp} disabled={otpSent} style={{ marginBottom: 8 }}>
                    {otpSent ? "OTP Sent" : "Send OTP"}
                  </Button>
                  <TextField
                    label="OTP"
                    name="otp"
                    value={otp}
                    onChange={e => setOtp(e.target.value)}
                    fullWidth
                    margin="normal"
                    placeholder="Enter OTP received"
                  />
                </div>
              )}
            </Grid>

          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>Cancel</Button>
        <Button onClick={handleSave} color="primary" disabled={loading}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SupportEditModal; 